import { Box, Typography, Button, } from "@mui/material";
import Grid from '@mui/material/Unstable_Grid2';
import SendIcon from '@mui/icons-material/Send';

// common
import { dic } from "@common/text_defs";

const BannerSection = () => {

  return (
    <Box component="section" className="section" id="intro" sx={{ pb: 0 }}>
      <Box sx={{ background: { sm: "url(./assets/banner/data_hub.jpg) center center/cover no-repeat", xs: '#0060fb' } }}>
        <Box sx={{
          display: "flex",
          justifyContent: "flex-end",
          padding: "0px 1rem",
          maxWidth: "1170px",
          margin: "0 auto",
          minHeight: '360px'
        }}>
          <Box sx={{
            width: '360px',
            pt: 5
          }}>
            <Typography component="div" sx={{ fontSize: '48px', color: '#ffffff', mb: 2 }}>{dic.services.data_hub.title}</Typography>
            <Typography component="div" sx={{ pl: 2, fontSize: '16px', color: '#ffffff', mb: 2 }}></Typography>
            <Button variant="contained" color="secondary" size="large" endIcon={<SendIcon />} sx={{ width: '250px' }}>
              お問い合わせ
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export { BannerSection };
